import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Form, Formik } from "formik";
import { Box } from "@mui/material";

import { Plan } from "../../../../Customer";
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import { UpdatePlanConfirmWindow } from "../../../index";
import { PLAN_VALIDATION_SCHEMA, CurrentPlanPrice } from "./utils";
import { ICustomerPlan } from "../../../../../../api/accounts/index.types";
import { IDiscountCodeForPlan } from "../../../../../../api/discounts/index.types";

const PlansTable = (): React.ReactElement => {
  const { plans } = useSelector((state) => state.customer.plans.data);

  const [editingPlan, setEditingPlan] = useState<Plan>();
  const [editingPlanDiscountCode, setEditingPlanDiscountCode] =
    useState<IDiscountCodeForPlan | null>(null);

  const [editingPlanSaveStatus, setEditingPlanSaveStatus] = useState("");

  const {
    data: { billing_history_by_plans },
  } = useSelector((state) => state.customer.plans);
  const getPlanPriceUsd = (plan: ICustomerPlan, index: number) => {
    return { price_usd: billing_history_by_plans[index]?.price_usd || plan.price_usd };
  };

  return (
    <Box sx={{ border: "1px solid rgba(0,0,0,.2)", borderRadius: "10px", padding: "8px" }}>
      {editingPlan && (
        <UpdatePlanConfirmWindow
          editingPlan={editingPlan}
          editingPlanSaveStatus={editingPlanSaveStatus}
          setEditingPlan={setEditingPlan}
          setEditingPlanSaveStatus={setEditingPlanSaveStatus}
          editingPlanDiscountCode={editingPlanDiscountCode}
        />
      )}

      <Formik
        validationSchema={PLAN_VALIDATION_SCHEMA}
        initialValues={{
          plans: plans.map((p, index) => ({
            ...p,
            price_usd: new CurrentPlanPrice(p, getPlanPriceUsd(p, index)).calculate(),
          })),
        }}
        enableReinitialize
        onSubmit={() => console.log()}
      >
        {() => {
          return (
            <Form>
              <table>
                <TableHead />
                <TableBody
                  setEditingPlanData={setEditingPlan}
                  setEditingPlanDiscountCode={setEditingPlanDiscountCode}
                />
              </table>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default PlansTable;
